import { render, staticRenderFns } from "./Commissions.vue?vue&type=template&id=0715daa5&scoped=true"
import script from "./Commissions.vue?vue&type=script&lang=js"
export * from "./Commissions.vue?vue&type=script&lang=js"
import style0 from "./Commissions.vue?vue&type=style&index=0&id=0715daa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0715daa5",
  null
  
)

export default component.exports